import React from "react";
import { Link } from "react-router-dom";
import ImagePlaceholder from "./ImagePlaceholder";

// Card used in the "Le mie selezioni" homepage section.
// Same elegant aesthetic as ProductCard but adds a personal recommendation note.
export const SelectionCard = ({ perfume }) => {
  const displayName = perfume.name || `Profumo ${perfume.slot_number}`;
  const hasImage = Boolean(perfume.main_image);

  return (
    <Link
      to={`/profumo/${perfume.id}`}
      data-testid={`selection-card-${perfume.slot_number}`}
      className="group block"
    >
      <div className="relative h-[320px] flex items-center justify-center overflow-hidden bg-[#F4F4F4]">
        {hasImage ? (
          <img
            src={perfume.main_image}
            alt={`${perfume.brand || ""} ${displayName}`.trim()}
            loading="lazy"
            className="max-w-[75%] max-h-[75%] w-auto h-auto object-contain object-center transition-transform duration-700 ease-out group-hover:scale-105"
          />
        ) : (
          <ImagePlaceholder />
        )}
      </div>

      <div className="pt-5">
        <div className="uppercase tracking-[0.22em] text-[10px] text-[#C5A059] mb-1.5 truncate">
          {perfume.brand || "—"}
        </div>
        <h3 className="font-heading text-xl md:text-2xl tracking-tight leading-tight truncate">
          {displayName}
        </h3>

        {perfume.personal_recommendation && (
          <p className="mt-3 text-sm text-black/65 font-light italic leading-relaxed line-clamp-4">
            “{perfume.personal_recommendation}”
          </p>
        )}
      </div>
    </Link>
  );
};

export default SelectionCard;
